import {
  Alert,
  Box,
  Dialog,
  DialogContent,
  IconButton,
  Typography,
} from '@mui/material'

import PropTypes from 'prop-types'
import clsx from 'clsx'
import useTranslations from '../../../i18n/useTranslations'

import { Link } from 'react-router-dom/cjs/react-router-dom'
import Letter from '../../../assets/animations/letter'
import { ReactComponent as X } from '../../../assets/icons/x.svg'
import useStyles from './styles'

const SuccessfulRecordingModal = ({ isOpen, hasPickUp, onClose }) => {
  const classes = useStyles()
  const t = useTranslations()

  return (
    <Dialog
      open={isOpen}
      disablePortal
      onClose={onClose}
      className={classes.dialog}
    >
      <Box className={classes.header}>
        <Letter width={400} height={200} />
        <IconButton className={classes.closeButton} onClick={onClose}>
          <X color="neutral.main" />
        </IconButton>
      </Box>
      <DialogContent>
        <Typography
          variant="h2"
          component="p"
          align="center"
          className={clsx('secondaryTitle')}
        >
          {t('shipping-recording:succesfull-title')}
        </Typography>

        <Typography
          variant="body1"
          color="neutral.main"
          className={classes.helperText}
        >
          {t('shipping-recording:succesfull-body', {
            nextPage: (
              <Link onClick={onClose} style={{ color: 'red' }}>
                {t('shipping-recording:succesfull-next-page')}
              </Link>
            ),
          })}
        </Typography>

        {hasPickUp ? (
          <Alert severity="info" iconAlignment="top">
            {t('shipping-recording:succesfull-alert')}
          </Alert>
        ) : null}
      </DialogContent>
    </Dialog>
  )
}

SuccessfulRecordingModal.propTypes = {
  isOpen: PropTypes.func,
  hasPickUp: PropTypes.bool,
  onClose: PropTypes.func,
}

export default SuccessfulRecordingModal
